/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { StartTrialContainerDocument } from '@fai/friendli-suite/generated/client/graphql';
import type {
  StartTrialContainerMutation,
  StartTrialContainerMutationVariables,
} from '@fai/friendli-suite/generated/client/graphql';
import client from '@fai/friendli-suite/shared/apollo/base-link';

export function startProductContainerTrial({ teamId }: { teamId: string }) {
  return client.mutate<StartTrialContainerMutation, StartTrialContainerMutationVariables>({
    mutation: StartTrialContainerDocument,
    variables: { input: { teamId } },
  });
}
